import classes from 'classnames';
import React from 'react';

import './RichText.scss';
import { stripDomainForMedia } from '../../util/sanitizeLink';

const toHTML = (str) => {
    const fns = [stripDomainForMedia];
    return { __html: fns.reduce((acc, fn) => fn(acc), str) };
};

export type RichTextProps = {
    className?: string;
    content: string;
};

export function RichText(props: RichTextProps) {
    return <div className={classes(['rich-text', props.className])} dangerouslySetInnerHTML={toHTML(props.content)} />;
}
